module.exports = __webpack_public_path__ + "img/speaker_14.305018d4.jpeg";